import type { RateCardDetailPublic } from "@common/client"
import { z } from "zod"
import type { GroupLabel } from "@/lib/grouping"

export const GROUPINGS = ["customer", "aircraft_type"] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  customer: "Customer",
  aircraft_type: "Aircraft type",
}

export function rateCardGroup(
  card: RateCardDetailPublic,
  grouping: Grouping,
): GroupLabel {
  switch (grouping) {
    case "customer":
      return card.customer
        ? {
            key: card.customer.id,
            label: card.customer.name ?? card.customer.email ?? "Unnamed",
          }
        : { key: "", label: "Any customer" }
    case "aircraft_type":
      return card.type_certificate_model_variant
        ? {
            key: card.type_certificate_model_variant.id,
            label: card.type_certificate_model_variant.marketing_name,
          }
        : { key: "", label: "Any aircraft" }
  }
}
